module.exports = __webpack_public_path__ + "img/001234567892.8e0a031f.png";